// Centralized filter lists for the ServicesTransactions page

export const statusFilters = [
  { label: "الكل", value: "all" },
  { label: "قيد الانتظار", value: "pending" },
  { label: "ناجحة", value: "success" },
  { label: "فاشلة", value: "failed" },
  { label: "دين", value: "debt" },
  { label: "مدفوع", value: "paid" },
];

export const operationTypes = [
  { label: "نوع العملية ", value: "all" },
  { label: "وحدات مفرق", value: "unit_single" },
  { label: "وحدات جملة", value: "unit_bulk" },
  { label: "فاتورة مفرق", value: "bill_single" },
  { label: "فاتورة جملة", value: "bill_bulk" },
  { label: "فاتورة", value: "bill" },
  { label: "كاش", value: "cash" },
  { label: "رصيد إلكتروني", value: "electronic_balance" },
];

export const providerFilters = [
  { label: "المزود", value: "all" },
  { label: "MTN", value: "MTN" },
  { label: "Syriatel", value: "Syriatel" },
];


export const operationTypeTranslations = {
  "unit_single": "وحدات مفرق",
  "unit_bulk": "وحدات جملة",
  "bill_single": "فاتورة مفرق",
  "bill_bulk": "فاتورة جملة",
  "bill": "فاتورة",
  "cash": "كاش",
  "electronic_balance": "رصيد إلكتروني",
};
